import { InAppReview } from "@capacitor-community/in-app-review";

export type ReviewClientDependencies = {
  review?: Pick<typeof InAppReview, "requestReview">;
};

export const createReviewClient = (
  dependencies: ReviewClientDependencies = {}
) => {
  const review = dependencies.review || InAppReview;
  return {
    request: async (): Promise<void> => {
      await review.requestReview();
    },
  };
};

export type ReviewClient = ReturnType<typeof createReviewClient>;
